import { ExtendedTokens } from '@primeuix/themes/types';

export const Extended: ExtendedTokens = {
  borderRadius: '0.5rem',
  secondary: {
    color: '{cyan.600}',
    inverseColor: '#ffffff',
    hoverColor: '{cyan.700}',
    activeColor: '{cyan.800}',
    50: '{cyan.50}',
    100: '{cyan.100}',
    200: '{cyan.200}',
    300: '{cyan.300}',
    400: '{cyan.400}',
    500: '{cyan.500}',
    600: '{cyan.600}',
    700: '{cyan.700}',
    800: '{cyan.800}',
    900: '{cyan.900}',
  },
};
